// Nút "Liên hệ" nổi (contact FAB): bấm pill để bung/thu cụm kênh;
// bấm ra ngoài hoặc nhấn Esc để thu lại.
(function () {
  var fab = document.querySelector('[data-contact-fab]');
  if (!fab) return;

  var trigger = fab.querySelector('.contact-fab__trigger');
  if (!trigger) return;

  function setOpen(open) {
    fab.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  trigger.addEventListener('click', function (event) {
    event.stopPropagation();
    setOpen(!fab.classList.contains('is-open'));
  });

  // Bấm ra ngoài widget → thu
  document.addEventListener('click', function (event) {
    if (!fab.contains(event.target)) setOpen(false);
  });

  // Esc → thu, trả focus về nút
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && fab.classList.contains('is-open')) {
      setOpen(false);
      trigger.focus();
    }
  });
})();
